import { createApp } from 'vue'
import App from "./App.vue";
import {createPinia} from "pinia";
import router from "@/router.js";
import "@/assets/scss/global.scss";
import 'bootstrap/scss/bootstrap.scss';
import 'bootstrap';
import { Modal } from 'bootstrap';
import useAuthStore from "@/stores/auth.store.js";
import VueToast from 'vue-toast-notification';
import axios from '@/services/axios.setup.js'; // Import Axios setup
import { errorToast } from './services/toast.service';
// Set jquery up for global use
import $ from 'jquery';
window.jQuery = $;
window.$ = $;

import 'vue-toast-notification/dist/theme-bootstrap.css';
import 'vue-select/dist/vue-select.css';
import bus from './bus';

import * as Sentry from "@sentry/vue";


const pinia = createPinia()

const app = createApp(App)

Sentry.init({
  app,
  dsn: "https://8d88292aef09045fa1438e8f733e56d5@o4508806945112064.ingest.de.sentry.io/4508806946881617",
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", '*.archimail.it',/^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});


app.use(pinia)
app.use(router)
app.use(VueToast)

app.provide('tryAsync', async function (promise, message, callback) {
  try {
    return await promise;
  } catch (err) {
    console.error(`Errore catturato (messaggio: ${message})`, err);

    if (message instanceof Function) {
      errorToast(message(err));
    } else {
      errorToast(message);
    }

    throw err;
  } finally {
    if (callback) {
      callback();
    }
  }
});

app.provide('axios', axios)

app.provide('capitalize', function (s) {
  if (typeof s !== "string") return ""
  return s.charAt(0).toUpperCase() + s.slice(1)
})

app.provide('urlParam', function(name) {
  const results = new RegExp("[?&]" + name + "=([^&#]*)").exec(window.location.href)
  if (results == null) {
    return null
  } else {
    return decodeURI(results[1]) || 0
  }
})

app.provide('userCan', function (permission) {
  const authStore = useAuthStore()
  let permissions = authStore?.user?.role?.permissions;

  if (!permissions) return false;

  for (let i in permissions) {
    if (permissions[i].name === permission) {
      return true
    }
  }

  return false
});

app.provide('isMobile', function () {
  /* eslint-disable */
  var check = false;
  (function(a) {
    if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
        )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);

  return check;
})

app.provide("userIs", function (role) {
  const authStore = useAuthStore()
  return authStore?.user?.role?.name === role ?? false;
})

/**
 * It makes sure that a function won't trigger
 * unless a specific amount of time (delay) has
 * passed since the last call. Useful for functions
 * that might be called very often in quick
 * succession, like those that are triggered by
 * key presses in a text input.
 */
app.provide("debounce", function (fn, delay) {
  let timeoutId = null;

  let inner = function () {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(fn, delay);
  }

  inner.cancel = function () {
    clearTimeout(timeoutId);
  }

  return inner;
})

/**
 * Provides a shortcut to both show a modal already
 * present in the dom, and initialize it by using
 * its ID as part of an event emission. It makes code
 * that triggers a modal way more concise
 **/
app.provide("showModal", function (id, ...data) {
  let modal = Modal.getOrCreateInstance(`#${id}`);
  modal.show();

  if (data != null) {
    bus.$emit(`init-${id}`, ...data);
  }
})

app.provide("hideModal", function (id) {
  let modal = Modal.getOrCreateInstance(`#${id}`);
  modal.hide();
})

app.provide("batches", function (list, size) {
  const batches = (arr, size) =>
    arr.length > size
      ? [arr.slice(0, size), ...batches(arr.slice(size), size)]
      : [arr];

  return batches(list, size);
})

app.mount("#app");
